import { PaymentMethodEnum, ProviderEnum } from '@/types/common';
import type { ICheckoutContext } from '@/types/context';
import type { Address } from '@/api/address';
import type { AdyenPaymentResponse, StripePaymentResponse } from '@/types/payment';
import { handleGenericStripePayment } from './genericStirpePaymentHandle';
import { handleAdyenPayment } from './adyenPaymentHandle';

// Stripe path expects `elements` inside params; the Adyen path expects the
// Adyen field map (which may carry an Address object for BILLING_ADDRESS).
// The two shapes don't overlap, so the public surface stays `unknown` and
// each branch downcasts to what it needs.
export const handleAfterPayPayment = async (
  checkout: ICheckoutContext,
  sendPaymentToServer: <TResponse>(params: unknown) => Promise<TResponse>,
  params?: unknown
): Promise<StripePaymentResponse | AdyenPaymentResponse> => {
  const afterPaySettings = checkout.paymentMethodsSettings.find(
    (pm) => pm.paymentMethodName === PaymentMethodEnum.AFTERPAY
  );

  if (!afterPaySettings) {
    throw new Error('AfterPay settings not found');
  }

  switch (afterPaySettings.provider) {
    case ProviderEnum.STRIPE:
      return (await handleGenericStripePayment(
        checkout,
        sendPaymentToServer,
        (params as Record<string, string>) ?? {}
      )) as StripePaymentResponse;
    case ProviderEnum.ADYEN:
      return (await handleAdyenPayment(
        checkout,
        sendPaymentToServer,
        (params as Record<string, string | Address>) ?? {}
      )) as AdyenPaymentResponse;
    default:
      throw new Error(`Unsupported provider for AfterPay: ${afterPaySettings.provider}`);
  }
};
